

// Our modules / classes

import Search from "./modules/Search"
import puechat from "./modules/puechat"
// Instantiate a new object using our modules/classes

const search = new Search()
const PueChat = new puechat()




